import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Statistic } from 'antd'
import { AppStore } from 'src/pc/store/AppStore'
import { UserInfoHS, getRechargeDetailListHS } from 'src/commons/store/UserStore'
import { formatTimeFixedOffset, commonJump } from 'src/pc/store/UIController'
import { BeijingTime } from 'src/commons/utils'
import { NEWCOMER_WELFARE_NO } from 'src/commons/utils/index'
import moment from 'moment'
import styled from 'styled-components'
import DDModal from 'src/pc/components/DDModal'
import modalBg from 'src/pc/assets/images/vip-center/update-modal-bg.png'
import Cookies from 'js-cookie'
import close from 'src/pc/assets/images/red-envelopes/close.png'
import modalBg1 from 'src/pc/assets/images/first-charge-new/modal-bg1.png'

const { Countdown } = Statistic

const NewcomerWelfareModal: React.FC = () => {
  const [endTime, setEndTime] = useState<number>(0)

  const cancel = () => {
    AppStore.newcomerWelfareModalVisible = false
  }

  const computerDownCoun = () => {
    const endOfDay = moment().endOf('day')
    setEndTime(endOfDay.valueOf())
  }

  useEffect(() => {
    computerDownCoun()
  }, [])

  useEffect(() => {
    if (AppStore.newcomerWelfareModalVisible) {
      window.gogReport?.('BoxClient_Firstcharge_view')
      Cookies.set('newcomerWelfareFlag', '1', { expires: 1 })
    }
  }, [AppStore.newcomerWelfareModalVisible])

  return (
    <StyledModal
      visible={AppStore.newcomerWelfareModalVisible}
      // visible={true}
      width={668}
      className="custom-1 UpgradeModal"
      closable={false}
      centered
      maskClosable={false}
      title={null}
      footer={null}
      bg={modalBg1}
    >
      <StyledTime>
        距活动结束
        <Countdown
          value={endTime}
          format={`${
            Math.abs(moment(endTime).diff(moment(formatTimeFixedOffset(BeijingTime.now())))) < 1000 * 3600 * 24
              ? 'HH:mm:ss.SSS'
              : 'D天 HH:mm:ss.SSS'
          }`}
          onFinish={() => computerDownCoun()}
          valueStyle={{ fontSize: 12, color: '#171614', marginLeft: 25, fontWeight: 'bold' }}
        />
      </StyledTime>
      {!!AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO]?.activityConfig && (
        <StyledGoodsList>
          <StyledGoodsItem>
            会员{'('}
            <span>
              {(
                Number(AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO].activityConfig.giftFour_vipTime) / 24
              ).toFixed(0)}
            </span>
            天{')'}
          </StyledGoodsItem>
          <StyledGoodsItem>
            云游戏{'('}
            <span>{AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO].activityConfig.giftFour_cloudTime}</span>h{')'}
          </StyledGoodsItem>
          <StyledGoodsItem>
            加速器{'('}
            <span>{AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO].activityConfig.giftFour_jsqName}</span>天{')'}
          </StyledGoodsItem>
          <StyledGoodsItem>任选一款游戏</StyledGoodsItem>
        </StyledGoodsList>
      )}

      <StyledBtn
        onClick={() => {
          window.gogReport?.('BoxClient_Firstcharge_receive')
          AppStore.newcomerWelfareModalVisible = false
          commonJump('/newcomerWelfare')
        }}
      />
      <StyledClose
        onClick={() => {
          window.gogReport?.('BoxClient_Firstcharge_close')
          cancel()
        }}
      >
        <img draggable={false} src={close} />
      </StyledClose>
    </StyledModal>
  )
}
/** 检测是否需要弹出首充礼包弹窗 */
export const checkNewcomerWelfareModal = () => {
  const userInfo = UserInfoHS.SuccessResult
  const rechargeDetailList = getRechargeDetailListHS.SuccessResult

  if (rechargeDetailList && rechargeDetailList.length > 0) {
    return false
  }
  if (!AppStore.activityConfigWithNo?.[NEWCOMER_WELFARE_NO] || !userInfo) {
    return false
  }
  /** 用户ID尾号是否在配置中 */
  const userLastID = `${userInfo?.id}`.charAt(`${userInfo?.id}`.length - 1)
  const userIdSuffix = AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO].activityConfig?.userIdSuffix?.split(',')
  if (userIdSuffix.findIndex(val => val === userLastID) === -1) {
    return false
  }
  /** 每天只弹一次首充礼包弹窗 */
  const newcomerWelfareFlag = Cookies.get('newcomerWelfareFlag')
  if (newcomerWelfareFlag === '1') {
    return false
  }
  /** 共享升级弹窗弹出的次数是否达到了配置的次数 */
  const num = AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO]?.activityConfig?.Vippopups
  const updateVipNum = localStorage.getItem(`update-vip-modal-num`) || 0
  if (num !== undefined && num !== '' && updateVipNum >= num) {
    return true
  }
  return false
}

const StyledBtn = styled.div`
  position: absolute;
  top: 238px;
  right: 139px;
  width: 150px;
  height: 53px;
  cursor: pointer;
`
const StyledGoodsItem = styled.div`
  font-size: 12px;
  color: #fffbe5;
  width: 82px;
  text-align: center;
  display: flex;
  align-items: center;
  white-space: nowrap;
  span {
    font-weight: bold;
    color: #ffd74b;
    white-space: nowrap;
  }
`
const StyledGoodsList = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 197px;
  left: 294px;
`
const StyledTime = styled.div`
  position: absolute;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  top: 50px;
  right: 61px;
`
const StyledClose = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  cursor: pointer;
`
const StyledModal = styled(DDModal)<{ bg: string }>`
  .ant-modal-content {
    background: url(${prop => prop.bg || modalBg}) no-repeat;
    height: 310px;
  }
  .ant-modal-body {
    background: none;
  }
  .ant-modal-close-x {
    display: none;
  }
`

export default observer(NewcomerWelfareModal)
